import React from 'react';
import { supportHtml } from '../static/supportIt';

const SupportIt = () => {
  return (
    <div style={{ width: "100%", overflowX: "hidden" }} dangerouslySetInnerHTML={{ __html: supportHtml(`${process.env.PUBLIC_URL}/images/mini-logo.png`) }}></div>
  )
}

export default SupportIt;